import * as APIAccount from './auth'
import * as APIGameSetting from './gameSetting'
import * as APIGameManagement from './gameManagement'
import * as APIProducts from './products'
import * as APISearchTool from './searchTool'
import * as APIQA from './qa'
import * as APIETC from './etc'

export {
  APIAccount,
  APIGameSetting,
  APIGameManagement,
  APIProducts,
  APISearchTool,
  APIQA,
  APIETC
}